import React, { createContext, useContext, useEffect, useState } from 'react';
import { company } from '../data/site';

const PageContext = createContext(null);

export const DEFAULT_CTA = {
  title: 'Ready to transform *your business?*',
  text: "Let's discuss how our solutions can help you achieve your goals.",
  label: 'Book a consultation'
};

// Holds per-page settings that live outside the page tree (the footer's call to action)
export const PageProvider = ({ children }) => {
  const [cta, setCta] = useState(DEFAULT_CTA);
  return <PageContext.Provider value={{ cta, setCta }}>{children}</PageContext.Provider>;
};

export const useFooterCta = () => useContext(PageContext)?.cta ?? DEFAULT_CTA;

/*
 * Per-page setup: document title, plus optional footer CTA copy (reset on leave).
 *   usePage('About Us')  ·  usePage('ERP', { title, text, label })
 */
export const usePage = (title, cta) => {
  const context = useContext(PageContext);
  const setCta = context?.setCta;
  const ctaKey = cta ? `${cta.title}|${cta.text}|${cta.label}` : '';

  useEffect(() => {
    document.title = title ? `${company.name} | ${title}` : `${company.name} | AI-Powered IT Solutions`;
  }, [title]);

  useEffect(() => {
    if (!setCta) return undefined;
    setCta(cta ? { ...DEFAULT_CTA, ...cta } : DEFAULT_CTA);
    return () => setCta(DEFAULT_CTA);
  }, [ctaKey, setCta]);
};
